var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 40 382.36 140",
    style: {
      enableBackground: "new 0 0 382.36 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#84C2EA;}\r\n\t.st1{fill:#58B0E3;}\r\n\t.st2{fill:#489ED2;}\r\n\t.st3{fill:#3198CD;}\r\n\t.st4{fill:#2887BF;}\r\n\t.st5{fill:#1074AB;}\r\n\t.st6{fill:#00679F;}\r\n\t.st7{fill:#005184;}\r\n\t.st8{fill:#004679;}\r\n\t.st9{fill:#003365;}\r\n\t.st10{fill:#002B60;}\r\n\t.st11{fill:#A98B2F;}\r\n\t.st12{fill:#196BAC;}\r\n\t.st13{fill:none;stroke:#A09F9F;stroke-width:0.2663;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.09,
    y1: 110.64,
    x2: 219.37,
    y2: 114.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.09,110.64L272.09,110.64c-0.04-0.06-49.44,0.35-49.44,0.35c-1.97,0.16-3.44,1.88-3.28,3.85v0 c0.16,1.97,1.88,3.44,3.85,3.28L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 272.09,
    y1: 110.64,
    x2: 220.07,
    y2: 101.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.09,110.64L272.09,110.64c-0.02-0.07-47.86-12.45-47.86-12.45c-1.94-0.36-3.81,0.93-4.16,2.87v0 c-0.36,1.94,0.93,3.81,2.87,4.16L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.09,
    y1: 110.64,
    x2: 224.36,
    y2: 87.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.09,110.64L272.09,110.64c0-0.08-42.97-24.42-42.97-24.42c-1.78-0.85-3.92-0.09-4.76,1.69v0 c-0.85,1.78-0.09,3.92,1.69,4.76L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 272.09,
    y1: 110.64,
    x2: 231.87,
    y2: 76.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M272.09,110.64L272.09,110.64c0.02-0.07-35.19-34.7-35.19-34.7c-1.5-1.28-3.76-1.1-5.04,0.4v0 c-1.28,1.5-1.1,3.76,0.4,5.04L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 272.09,
    y1: 110.64,
    x2: 242.11,
    y2: 67.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.09,110.64L272.09,110.64c0.03-0.07-25.01-42.62-25.01-42.62c-1.12-1.63-3.35-2.04-4.97-0.92h0 c-1.63,1.12-2.04,3.35-0.92,4.97L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 272.09,
    y1: 110.64,
    x2: 254.4,
    y2: 60.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.09,110.64L272.09,110.64c0.05-0.06-13.13-47.63-13.13-47.63c-0.66-1.86-2.7-2.83-4.57-2.17v0 c-1.86,0.66-2.83,2.7-2.17,4.57L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 272.09,
    y1: 110.64,
    x2: 267.89,
    y2: 57.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.09,110.64L272.09,110.64c0.06-0.04-0.35-49.4-0.35-49.4c-0.16-1.97-1.88-3.44-3.85-3.28l0,0 c-1.97,0.16-3.44,1.88-3.28,3.85L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 272.09,
    y1: 110.64,
    x2: 281.67,
    y2: 58.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.09,110.64L272.09,110.64c0.07-0.02,12.44-47.8,12.44-47.8c0.36-1.94-0.93-3.81-2.87-4.16l0,0 c-1.94-0.36-3.81,0.93-4.16,2.87L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 272.09,
    y1: 110.64,
    x2: 294.79,
    y2: 62.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M272.09,110.64L272.09,110.64c0.08,0,24.39-42.94,24.39-42.94c0.85-1.78,0.09-3.92-1.69-4.76v0 c-1.78-0.85-3.92-0.09-4.76,1.69L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 272.09,
    y1: 110.64,
    x2: 306.36,
    y2: 70.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M272.09,110.64L272.09,110.64c0.07,0.02,34.67-35.16,34.67-35.16c1.28-1.5,1.1-3.76-0.4-5.04v0 c-1.5-1.28-3.76-1.1-5.04,0.4L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 272.09,
    y1: 110.64,
    x2: 321.9,
    y2: 92.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M272.09,110.64L272.09,110.64c0.06,0.05,47.63-13.09,47.63-13.09c1.86-0.66,2.83-2.7,2.17-4.57v0 c-0.66-1.86-2.7-2.83-4.57-2.17L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 272.09,
    y1: 110.64,
    x2: 324.77,
    y2: 106.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M272.09,110.64L272.09,110.64c0.04,0.06,49.4-0.32,49.4-0.32c1.97-0.16,3.44-1.88,3.28-3.85v0 c-0.16-1.97-1.88-3.44-3.85-3.28L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 272.09,
    y1: 110.64,
    x2: 324.26,
    y2: 120.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.09,110.64L272.09,110.64c0.02,0.07,48.01,12.48,48.01,12.48c1.94,0.36,3.81-0.93,4.16-2.87v0 c0.36-1.94-0.93-3.81-2.87-4.16L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 272.09,
    y1: 110.64,
    x2: 319.89,
    y2: 133.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.09,110.64L272.09,110.64c0,0.08,43.03,24.33,43.03,24.33c1.78,0.85,3.92,0.09,4.76-1.69v0 c0.85-1.78,0.09-3.92-1.69-4.76L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 272.09,
    y1: 110.64,
    x2: 312.29,
    y2: 144.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.09,110.64L272.09,110.64c-0.02,0.07,35.16,34.7,35.16,34.7c1.5,1.28,3.76,1.1,5.04-0.4l0,0 c1.28-1.5,1.1-3.76-0.4-5.04L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 272.09,
    y1: 110.64,
    x2: 302.05,
    y2: 154.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.09,110.64L272.09,110.64c-0.03,0.07,24.98,42.62,24.98,42.62c1.12,1.63,3.35,2.04,4.97,0.92l0,0 c1.63-1.12,2.04-3.35,0.92-4.97L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 272.09,
    y1: 110.64,
    x2: 289.76,
    y2: 160.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M272.09,110.64L272.09,110.64c-0.05,0.06,13.1,47.63,13.1,47.63c0.66,1.86,2.7,2.83,4.57,2.17l0,0 c1.86-0.66,2.83-2.7,2.17-4.57L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 272.09,
    y1: 110.64,
    x2: 276.27,
    y2: 163.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.09,110.64L272.09,110.64c-0.06,0.04,0.33,49.39,0.33,49.39c0.16,1.97,1.88,3.44,3.85,3.28l0,0 c1.97-0.16,3.44-1.88,3.28-3.85L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 272.09,
    y1: 110.64,
    x2: 262.49,
    y2: 162.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.09,110.64L272.09,110.64c-0.07,0.02-12.47,47.79-12.47,47.79c-0.36,1.94,0.93,3.81,2.87,4.16l0,0 c1.94,0.36,3.81-0.93,4.16-2.87L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 272.09,
    y1: 110.64,
    x2: 249.37,
    y2: 158.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.09,110.64L272.09,110.64c-0.08,0-24.41,42.94-24.41,42.94c-0.85,1.78-0.09,3.92,1.69,4.76h0 c1.78,0.85,3.92,0.09,4.76-1.69L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 272.09,
    y1: 110.64,
    x2: 315.33,
    y2: 80.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M272.09,110.64L272.09,110.64c0.07,0.03,42.37-25.45,42.37-25.45c1.61-1.14,2-3.37,0.86-4.98v0 c-1.14-1.61-3.37-2-4.98-0.86L272.09,110.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 258.78,
    y1: 120.03,
    x2: 228.28,
    y2: 140.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M258.78,120.03L258.78,120.03c0.01,0.08-25.52,21.36-25.52,21.36c-1.67,1.09-3.9,0.63-4.99-1.04h0 c-1.09-1.67-0.63-3.9,1.04-4.99L258.78,120.03z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M258.78,120.03L258.78,120.03c-0.02,0.07-42.49,12.43-42.49,12.43c-1.95,0.39-3.85-0.87-4.24-2.82v0 c-0.39-1.95,0.87-3.85,2.82-4.24L258.78,120.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M258.76,120.12L258.76,120.12c0.04,0.07-21.26,38.83-21.26,38.83c-1.1,1.66-3.34,2.11-5,1.01l0,0 c-1.66-1.1-2.11-3.34-1.01-5L258.76,120.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94.66,132.14h-7.57c-0.24,0-0.43,0.19-0.43,0.43v7.07v1.77h1.16c0,0,0-8.14,0-8.12l6.84,0V132.14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "94.66,136.02 88.2,136.02 88.2,137.19 94.66,137.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M107.65,141.41l0.04-4.13l7.38,0.07l0,0l0.03,0l0.02-2.38c0.01-1.35-0.86-2.81-2.8-2.83l-4.99-0.05 c-0.45,0-0.81,0.35-0.81,0.8l-0.08,8.52H107.65z M107.73,133.32l4.6,0.04c1.1,0.01,1.6,0.85,1.59,1.63l-0.01,1.14l-6.2-0.06 L107.73,133.32z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "115.43,141.41 113.53,137.74 112.13,137.74 114.04,141.41  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M164.77,134.14c0.38-0.27,0.51-0.87,0.28-1.33c-0.24-0.53-0.94-0.59-1.23-0.59h-9.07v1.15l9.03-0.02 c-0.8,0.57-6.72,4.76-8.66,6.14c-0.42,0.3-0.47,0.95-0.25,1.37c0.17,0.36,0.58,0.54,1.26,0.54l9.02-0.01h0.05v-1.15l-9.07,0.03 C157.19,139.51,162.27,135.9,164.77,134.14z M156.07,140.31L156.07,140.31l0,0.02L156.07,140.31z M156.07,140.29l0-0.01 L156.07,140.29L156.07,140.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M99.76,132.13c-0.42-0.02-1.01,0.21-1.22,0.61l-4.5,8.67h1.36l4.22-7.92c0.03-0.06,0.09-0.07,0.13-0.07 c0.04,0,0.09,0.01,0.12,0.08l3.77,7.92h0.01H105l-4.01-8.63C100.82,132.4,100.21,132.14,99.76,132.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M122.49,132.13c-0.42-0.02-1.01,0.21-1.22,0.61l-4.5,8.67h1.36l4.22-7.92c0.03-0.06,0.09-0.07,0.13-0.07 c0.04,0,0.09,0.01,0.12,0.08l3.77,7.89l0.01,0.03h1.35l-4.01-8.63C123.55,132.4,122.94,132.14,122.49,132.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M148.39,132.13c-0.42-0.02-1.01,0.21-1.22,0.61l-4.5,8.67h1.36l4.22-7.92c0.03-0.06,0.09-0.07,0.13-0.07 c0.04,0,0.09,0.01,0.12,0.08l3.77,7.89l0.01,0.03h1.35l-4.01-8.63C149.45,132.4,148.84,132.14,148.39,132.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M172.44,132.13c-0.42-0.02-1.01,0.21-1.22,0.61l-4.5,8.67h1.36l4.22-7.92c0.03-0.06,0.09-0.07,0.13-0.07 c0.04,0,0.09,0.01,0.12,0.08l3.77,7.89l0.01,0.03h1.35l-4.01-8.63C173.49,132.4,172.89,132.14,172.44,132.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M185.98,132.78c-0.18-0.38-0.78-0.64-1.24-0.65c-0.42-0.02-1.01,0.21-1.22,0.61l-4.5,8.67h1.36l4.22-7.92 c0.03-0.06,0.09-0.07,0.13-0.07c0.04,0,0.09,0.01,0.12,0.08l3.77,7.89l0.01,0.03h1.35L185.98,132.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M192.73,141.35l0.04-4.06l7.38,0.07l0,0l0.03,0l0.02-2.38c0.01-1.35-0.86-2.81-2.8-2.83l-4.99-0.05 c-0.45,0-0.81,0.35-0.81,0.8l-0.08,8.44L192.73,141.35z M192.81,133.32l4.6,0.04c1.1,0.01,1.6,0.85,1.59,1.63l-0.01,1.14 l-6.2-0.06L192.81,133.32z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "200.51,141.41 198.61,137.74 197.21,137.74 199.12,141.41  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M140.22,136.86c0.93-0.71,0.91-1.87,0.91-1.87c0-1.36-0.9-2.83-2.86-2.83h-5.32c-0.4,0-0.72,0.32-0.72,0.72 v8.54h8.88h0.03V139C141.13,138.22,140.84,137.41,140.22,136.86z M133.45,133.39l4.84-0.01c1.11,0,1.58,0.7,1.59,1.35 c0.02,0.83-0.62,1.5-1.59,1.43h-4.84V133.39z M139.9,140.18h-6.46v-2.16v-0.61l4.81-0.01c0,0,0.01,0,0.01,0c0.01,0,0.01,0,0.02,0 c1.11,0,1.62,0.85,1.62,1.63L139.9,140.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.53,121.06c-1.21,0-2.22,0.97-2.22,2.22c0,1.21,1.02,2.22,2.22,2.22c1.26,0,2.27-1.02,2.27-2.27 C129.81,122.03,128.74,121.06,127.53,121.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M140.81,89.17v17.41c0,6.72-5.02,9.79-9.69,9.79h-15.51c-0.87,0-1.57-0.7-1.57-1.57V79.87v0.12h4.22 c0,0,0,29.48,0,32.17l12.77,0.01c2.69,0,5.59-1.74,5.59-5.55l-0.03-17.46H140.81z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.83,
    y: 80.1,
    className: "st11",
    width: 4.22,
    height: 36.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "109.02,125.57 109.02,88.96 104.8,88.96 104.83,125.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "90.85,125.57 90.85,88.96 86.63,88.96 86.66,125.57  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.68,
    y: 79.91,
    className: "st12",
    width: 4.22,
    height: 36.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106.89,80c-1.21,0-2.22,0.97-2.22,2.22c0,1.21,1.02,2.22,2.22,2.22c1.26,0,2.27-1.02,2.27-2.27 C109.16,80.97,108.1,80,106.89,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M197.47,89.07h-14.34c-7.06,0-10.28,5.27-10.28,10.17v8.65h0.11v0h22.69v3.98l-36.41,0.09l0-0.29v-0.65 h0.01V95.86c0-0.01,0-0.01,0-0.02v-7h-4.22v22.17h0v14.56h4.19v-9.22l38.38,0.01c1.35,0,2.45-1.1,2.45-2.45V91.66 C200.07,90.23,198.91,89.07,197.47,89.07z M195.66,103.46h-18.4l0-4.12c0-2.83,1.83-5.87,5.82-5.87l12.58,0.03V103.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186.56,80c-1.21,0-2.22,0.97-2.22,2.22c0,1.21,1.02,2.22,2.22,2.22c1.26,0,2.27-1.02,2.27-2.27 C188.84,80.97,187.77,80,186.56,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M86.59,116.38"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.546832c9.svg";
export { ForwardRef as ReactComponent };